class ModuleProvider {
	modules = [];
	context = {};

	register(module) {
		this.modules.push(module);
	}

	getModules() {
		return this.modules;
	}
}

export default ModuleProvider;



// WEBPACK FOOTER //
// ./src/core/providers/moduleProvider.js